/* ARBACH Produktgalerie — Wischen, Pfeile, Vorschaubilder, Vollbild mit Zoom.
   Auftrag 20, A5, Befund N6 (05.10.2026). Kein Framework, ES5 wie arbach.js.

   Die Bühne ist eine scroll-snap-Reihe und funktioniert ohne dieses Skript
   (Wischen, Sprunglinks der Vorschaubilder, Bild-Link auf die große Datei).
   Dieses Skript ergänzt:
     · Pfeile (im Markup hidden) — endlos, vom letzten Bild „vor" zum ersten,
     · Vorschaubilder folgen der Reihe (aria-current) und springen ohne Hash,
     · Vollbild <dialog>: Wischen, Zwei-Finger-Zoom, Doppeltipp, Ziehen im
       gezoomten Bild, X, Escape, Zurück-Geste (pushState/popstate),
       Dateien erst beim ersten Öffnen.
   RTL: scrollLeft läuft bei dir=rtl ins Negative — Position deshalb mit
   Vorzeichen rechnen, nicht über offsetLeft. */
(function () {
  'use strict';

  var RTL = document.documentElement.getAttribute('dir') === 'rtl';
  var REDUCE = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var MAX_ZOOM = 4;
  var DOPPEL_ZOOM = 2.5;

  function klemme(v, min, max) { return Math.max(min, Math.min(max, v)); }

  // Gemeinsame Mechanik einer scroll-snap-Reihe: Index lesen, hinscrollen.
  function reihe(spur, beimWechsel) {
    var n = spur.children.length;
    var aktuell = 0;
    function breite() { return spur.clientWidth || 1; }
    function index() { return klemme(Math.round(Math.abs(spur.scrollLeft) / breite()), 0, n - 1); }
    function geh(i, sanft) {
      if (n < 1) return;
      var ueberlauf = i < 0 || i >= n;
      i = (i + n) % n;
      spur.scrollTo({ left: (RTL ? -1 : 1) * i * breite(), behavior: (sanft && !ueberlauf && !REDUCE) ? 'smooth' : 'auto' });
      setze(i);
    }
    function setze(i) {
      if (i === aktuell) return;
      var alt = aktuell;
      aktuell = i;
      beimWechsel(i, alt);
    }
    var raf = 0;
    spur.addEventListener('scroll', function () {
      if (raf) return;
      raf = window.requestAnimationFrame(function () { raf = 0; setze(index()); });
    }, { passive: true });
    return { geh: geh, n: n, aktuell: function () { return aktuell; }, setze: setze };
  }

  function init(root) {
    if (root.getAttribute('data-galerie-bereit') === '1') return;
    root.setAttribute('data-galerie-bereit', '1');
    var spur = root.querySelector('[data-galerie-spur]');
    if (!spur) return;
    var thumbs = root.querySelectorAll('[data-galerie-thumb]');
    var nav = root.querySelector('[data-galerie-nav]');

    var haupt = reihe(spur, function (i) {
      for (var t = 0; t < thumbs.length; t++) {
        if (t === i) thumbs[t].setAttribute('aria-current', 'true');
        else thumbs[t].removeAttribute('aria-current');
      }
      // Bei mehr als fünf Vorschaubildern das aktive in Sicht halten
      var th = thumbs[i], zeile = th && th.parentNode;
      if (zeile && zeile.scrollWidth > zeile.clientWidth + 1) {
        var z = zeile.getBoundingClientRect(), r = th.getBoundingClientRect();
        if (r.left < z.left || r.right > z.right) {
          zeile.scrollBy({ left: (r.left + r.width / 2) - (z.left + z.width / 2), behavior: REDUCE ? 'auto' : 'smooth' });
        }
      }
    });

    if (nav && haupt.n > 1) {
      nav.removeAttribute('hidden');
      nav.querySelector('[data-galerie-zurueck]').addEventListener('click', function () { haupt.geh(haupt.aktuell() - 1, true); });
      nav.querySelector('[data-galerie-vor]').addEventListener('click', function () { haupt.geh(haupt.aktuell() + 1, true); });
    }
    Array.prototype.forEach.call(thumbs, function (th, i) {
      th.addEventListener('click', function (e) { e.preventDefault(); haupt.geh(i, true); });
    });

    // ------------------------------------------------------------ Vollbild
    var dialog = root.querySelector('[data-galerie-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;  // dann bleibt der Bild-Link
    var vspur = dialog.querySelector('[data-galerie-vspur]');
    var vslides = vspur.children;
    var zaehler = dialog.querySelector('[data-galerie-zaehler]');
    var zuKnopf = dialog.querySelector('[data-galerie-zu]');
    var ausloeser = null;
    var imVerlauf = false;
    var geladen = false;

    var voll = reihe(vspur, function (i, alt) {
      zoomZurueck(alt);
      if (zaehler) zaehler.textContent = (i + 1) + ' / ' + vslides.length;
    });

    function laden(start) {
      if (geladen) return;
      geladen = true;
      for (var k = 0; k < vslides.length; k++) {
        var li = vslides[k];
        var img = document.createElement('img');
        img.className = 'arbach-lightbox__img';
        img.alt = li.getAttribute('data-alt') || '';
        img.decoding = 'async';
        img.draggable = false;
        if (k !== start) img.loading = 'lazy';
        img.sizes = '100vw';
        img.srcset = li.getAttribute('data-srcset') || '';
        img.src = li.getAttribute('data-src') || '';
        li.querySelector('[data-galerie-zoomflaeche]').appendChild(img);
        zoomBinden(li.querySelector('[data-galerie-zoomflaeche]'));
      }
    }

    function oeffne(i, von) {
      ausloeser = von || null;
      laden(i);
      dialog.showModal();
      document.documentElement.classList.add('arbach-lightbox-offen');
      voll.geh(i, false);
      if (zaehler) zaehler.textContent = (i + 1) + ' / ' + vslides.length;
      // Nach dem Layout noch einmal genau einrasten (die Breite steht erst jetzt fest)
      window.requestAnimationFrame(function () { voll.geh(i, false); });
      try { window.history.pushState({ arbachGalerie: true }, ''); imVerlauf = true; } catch (e) { imVerlauf = false; }
      try { zuKnopf.focus({ preventScroll: true }); } catch (e) { zuKnopf.focus(); }
    }

    function schliesse(ausDemVerlauf) {
      if (!dialog.open) return;
      var i = voll.aktuell();
      zoomZurueck(i);
      dialog.close();
      document.documentElement.classList.remove('arbach-lightbox-offen');
      haupt.geh(i, false);
      if (imVerlauf && !ausDemVerlauf) { imVerlauf = false; window.history.back(); }
      imVerlauf = false;
      if (ausloeser) { try { ausloeser.focus({ preventScroll: true }); } catch (e) { ausloeser.focus(); } }
    }

    Array.prototype.forEach.call(root.querySelectorAll('[data-galerie-oeffnen]'), function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        oeffne(parseInt(a.getAttribute('data-galerie-oeffnen'), 10) || 0, a);
      });
    });
    zuKnopf.addEventListener('click', function () { schliesse(false); });
    // Escape: der Dialog meldet „cancel" — selbst schließen, damit Verlauf und Fokus stimmen
    dialog.addEventListener('cancel', function (e) { e.preventDefault(); schliesse(false); });
    window.addEventListener('popstate', function () { if (dialog.open) { imVerlauf = false; schliesse(true); } });
    var vz = dialog.querySelector('[data-galerie-vzurueck]');
    var vv = dialog.querySelector('[data-galerie-vvor]');
    if (vz) vz.addEventListener('click', function () { voll.geh(voll.aktuell() - 1, true); });
    if (vv) vv.addEventListener('click', function () { voll.geh(voll.aktuell() + 1, true); });
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { voll.geh(voll.aktuell() + (RTL ? -1 : 1), true); e.preventDefault(); }
      if (e.key === 'ArrowLeft') { voll.geh(voll.aktuell() + (RTL ? 1 : -1), true); e.preventDefault(); }
    });

    // ---------------------------------------------------------------- Zoom
    // Zustand je Fläche: Maßstab s und Verschiebung tx/ty (CSS-Pixel), Ursprung Mitte.
    function zustand(f) {
      if (!f._z) f._z = { s: 1, tx: 0, ty: 0 };
      return f._z;
    }
    function anwenden(f, sofort) {
      var z = zustand(f), img = f.firstElementChild;
      if (!img) return;
      // Nicht weiter verschieben, als das vergrößerte Bild über die Fläche ragt
      var w = img.offsetWidth, h = img.offsetHeight, fw = f.clientWidth, fh = f.clientHeight;
      var mx = Math.max(0, (w * z.s - fw) / 2), my = Math.max(0, (h * z.s - fh) / 2);
      z.tx = klemme(z.tx, -mx, mx);
      z.ty = klemme(z.ty, -my, my);
      img.classList.toggle('is-zieht', !!sofort);
      img.style.transform = z.s === 1 ? '' : 'translate(' + z.tx + 'px,' + z.ty + 'px) scale(' + z.s + ')';
      f.classList.toggle('is-gezoomt', z.s > 1);
    }
    function zoomAuf(f, s, px, py) {
      // (px, py) = Punkt relativ zur Flächenmitte, der unter dem Finger bleiben soll
      var z = zustand(f);
      var neu = klemme(s, 1, MAX_ZOOM);
      var bx = (px - z.tx) / z.s, by = (py - z.ty) / z.s;   // Bildpunkt unter dem Finger
      z.s = neu;
      z.tx = px - bx * neu;
      z.ty = py - by * neu;
      if (neu === 1) { z.tx = 0; z.ty = 0; }
    }
    function zoomZurueck(i) {
      var li = vslides[i];
      var f = li && li.querySelector('[data-galerie-zoomflaeche]');
      if (!f || !f._z || f._z.s === 1) return;
      f._z.s = 1; f._z.tx = 0; f._z.ty = 0;
      anwenden(f, true);
    }
    function relativ(f, x, y) {
      var r = f.getBoundingClientRect();
      return { x: x - (r.left + r.width / 2), y: y - (r.top + r.height / 2) };
    }

    function zoomBinden(f) {
      var pinch = null, zug = null, letzterTipp = 0, tippX = 0, tippY = 0, bewegt = false;

      f.addEventListener('touchstart', function (e) {
        var z = zustand(f);
        if (e.touches.length === 2) {
          // Zwei Finger: eigener Zoom, kein Seitenzoom und kein Wischen
          e.preventDefault();
          var a = e.touches[0], b = e.touches[1];
          var m = relativ(f, (a.clientX + b.clientX) / 2, (a.clientY + b.clientY) / 2);
          pinch = { d: Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY) || 1, s: z.s, tx: z.tx, ty: z.ty, m: m };
          zug = null;
        } else if (e.touches.length === 1) {
          var t = e.touches[0];
          bewegt = false;
          if (z.s > 1) zug = { x: t.clientX, y: t.clientY, tx: z.tx, ty: z.ty };
        }
      }, { passive: false });

      f.addEventListener('touchmove', function (e) {
        var z = zustand(f);
        if (pinch && e.touches.length === 2) {
          e.preventDefault();
          var a = e.touches[0], b = e.touches[1];
          var d = Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY) || 1;
          var m = relativ(f, (a.clientX + b.clientX) / 2, (a.clientY + b.clientY) / 2);
          // vom Startzustand aus rechnen: Bildpunkt unter der Anfangsmitte folgt der Fingermitte
          z.s = pinch.s; z.tx = pinch.tx; z.ty = pinch.ty;
          zoomAuf(f, pinch.s * d / pinch.d, pinch.m.x, pinch.m.y);
          z.tx += m.x - pinch.m.x;
          z.ty += m.y - pinch.m.y;
          anwenden(f, true);
          bewegt = true;
        } else if (zug && e.touches.length === 1 && z.s > 1) {
          e.preventDefault();
          var t = e.touches[0];
          z.tx = zug.tx + (t.clientX - zug.x);
          z.ty = zug.ty + (t.clientY - zug.y);
          anwenden(f, true);
          bewegt = true;
        } else if (e.touches.length === 1) {
          bewegt = true;
        }
      }, { passive: false });

      f.addEventListener('touchend', function (e) {
        if (pinch && e.touches.length < 2) {
          pinch = null;
          var z = zustand(f);
          if (z.s < 1.05) { z.s = 1; z.tx = 0; z.ty = 0; }
          anwenden(f, false);
          // ein verbleibender Finger zieht weiter
          if (e.touches.length === 1 && z.s > 1) zug = { x: e.touches[0].clientX, y: e.touches[0].clientY, tx: z.tx, ty: z.ty };
          return;
        }
        zug = null;
        if (e.changedTouches.length === 1 && !bewegt) {
          // Doppeltipp: 1 ↔ 2,5-fach an der getippten Stelle
          var c = e.changedTouches[0], jetzt = Date.now();
          if (jetzt - letzterTipp < 300 && Math.hypot(c.clientX - tippX, c.clientY - tippY) < 30) {
            e.preventDefault();
            var p = relativ(f, c.clientX, c.clientY);
            zoomAuf(f, zustand(f).s > 1 ? 1 : DOPPEL_ZOOM, p.x, p.y);
            anwenden(f, false);
            letzterTipp = 0;
          } else {
            letzterTipp = jetzt; tippX = c.clientX; tippY = c.clientY;
          }
        }
      });

      // Maus (Rechner): Klick zoomt an der Stelle bzw. zurück, Ziehen verschiebt
      var maus = null, mausBewegt = false;
      f.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        var z = zustand(f);
        mausBewegt = false;
        maus = { x: e.clientX, y: e.clientY, tx: z.tx, ty: z.ty };
        if (z.s > 1) e.preventDefault();
      });
      window.addEventListener('mousemove', function (e) {
        if (!maus) return;
        var z = zustand(f);
        if (Math.hypot(e.clientX - maus.x, e.clientY - maus.y) > 4) mausBewegt = true;
        if (z.s > 1 && mausBewegt) {
          z.tx = maus.tx + (e.clientX - maus.x);
          z.ty = maus.ty + (e.clientY - maus.y);
          anwenden(f, true);
        }
      });
      window.addEventListener('mouseup', function (e) {
        if (!maus) return;
        var war = maus;
        maus = null;
        if (mausBewegt || Math.hypot(e.clientX - war.x, e.clientY - war.y) > 4) { anwenden(f, false); return; }
        if (e.target !== f.firstElementChild) return;   // nur Klicks aufs Bild zoomen
        var p = relativ(f, e.clientX, e.clientY);
        zoomAuf(f, zustand(f).s > 1 ? 1 : DOPPEL_ZOOM, p.x, p.y);
        anwenden(f, false);
      });
    }
  }

  function alle() {
    var g = document.querySelectorAll('[data-galerie]');
    for (var i = 0; i < g.length; i++) init(g[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle);
  else alle();
  // Theme-Editor rendert die Sektion neu
  document.addEventListener('shopify:section:load', alle);
})();
